import { Observable } from 'rxjs';
import { AjaxConfig, AjaxResponse } from 'rxjs/ajax';

import { AppStore } from 'app/store';
import { SecurityUtils } from 'app/utils/security-utils';

import { HttpHandler } from '../http-handler';
import { Interceptor } from '../interceptor';

export class AuthHeaderInterceptor implements Interceptor {
    public intercept<T>(store: AppStore, req: AjaxConfig, next: HttpHandler<T>): Observable<AjaxResponse<T>> {
        req.headers = {
            Authorization: SecurityUtils.getToken(),
            ...req.headers,
        };

        return next.handle(req);
    }
}
